<template>
  <div class="categories">
    <h5 class="mb-5">Categorias</h5>

    <carousel
      :per-page-custom="[
        [768, 4],
        [992, 6],
        [1300, 6]
      ]"
      :navigation-enabled="true"
      navigation-next-label="<i class='icon-angle-right'></i>"
      navigation-prev-label="<i class='icon-angle-left'></i>"
    >
      <slide
        v-for="item in items"
        :key="item.id"
        class="px-3"
        aria-hidden="true"
      >
        <category @select="click" :name="item.name" />
      </slide>
    </carousel>
  </div>
</template>
<script>
import Category from "@/components/marketplace/Category";
export default {
  components: {
    Category
  },
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    setTimeout(() => {
      let slides = document.getElementsByClassName("VueCarousel-dot");
      slides.forEach((item, index) => {
        slides[index].removeAttribute("title");
      });
    }, 200);
  },
  methods: {
    click(val) {
      this.$emit("select", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.categories {
  ::v-deep .VueCarousel {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  ::v-deep .VueCarousel-pagination {
    bottom: -41px;
    position: absolute;
  }

  ::v-deep .VueCarousel-dot {
    border-radius: 0px;
    height: 2px !important;
    width: 20px !important;
    background-color: #c4c4c4 !important;

    &.VueCarousel-dot--active {
      background-color: #9155ec !important;
      width: 30px !important;
    }
  }

  ::v-deep .VueCarousel-dot:focus {
    outline: none;
  }

  ::v-deep .VueCarousel-navigation-next {
    transform: translateX(100%);
    text-align: left;
    margin-right: 25px;
    margin-top: -11.5%;
    font-size: 20px;

    @media screen and (max-width: 768px) {
      margin-top: -38%;
    }
  }

  ::v-deep .VueCarousel-navigation-prev {
    transform: translateX(100%);
    text-align: left;
    margin-left: 93.8%;
    margin-top: -11.5%;
    font-size: 20px;

    @media screen and (max-width: 768px) {
      margin-left: 80%;
      margin-top: -38%;
    }
  }

  ::v-deep .VueCarousel-navigation-prev:focus {
    outline: none;
  }

  ::v-deep .VueCarousel-navigation-next:focus {
    outline: none;
  }
}
</style>
